
import { useAuth0 } from './use-auth0';

// Create a simple Vue plugin to expose the wrapper object throughout the application
const Auth0Plugin = {
  install(Vue, options) {
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$auth = useAuth0(options);
  },
};

export default Auth0Plugin;
